import { formatToCurrency } from "src/common/util";
import { SummaryType } from "src/components/SearchableTable/types";
import { searchableTableUtils } from "src/components/SearchableTable/utils"

export enum ColumnsKeys {
    NO = 'key',
    DESCRIPTION = 'description',
    QTY = 'qty',
    PRICE = 'price',
    TOTAL = 'total',
    ACTIONS = 'actions',
}

export const tableColumns: any = [
    {
        title: "No",
        dataIndex: ColumnsKeys.NO,
        key: ColumnsKeys.NO,
        align: searchableTableUtils.alignment.centerAlign,
    },
    {
        title: "Description",
        dataIndex: ColumnsKeys.DESCRIPTION,
        key: ColumnsKeys.DESCRIPTION,
        align: searchableTableUtils.alignment.centerAlign,
    },
    {
        title: "Qty",
        dataIndex: ColumnsKeys.QTY,
        key: ColumnsKeys.QTY,
        align: searchableTableUtils.alignment.centerAlign,
    },
    {
        title: "Price",
        dataIndex: ColumnsKeys.PRICE,
        key: ColumnsKeys.PRICE,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => formatToCurrency(value),
    },
    {
        title: "Total",
        dataIndex: ColumnsKeys.TOTAL,
        key: ColumnsKeys.TOTAL,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => formatToCurrency(value),
    },

];

export const summaryColumns: Partial<Record<ColumnsKeys, SummaryType>> = {
    [ColumnsKeys.TOTAL]: SummaryType.SUM,
}

export const policiesTableColumns: any = [
    {
        title: "No",
        dataIndex: ColumnsKeys.NO,
        key: ColumnsKeys.NO,
        align: searchableTableUtils.alignment.centerAlign,
    },
    {
        title: "Name",
        dataIndex: "name",
        key: "name",
        align: searchableTableUtils.alignment.centerAlign,
    },
    {
        title: "Description",
        dataIndex: "description",
        key: "description",
        align: searchableTableUtils.alignment.centerAlign,
    },
];